import { DefaultLayout } from '../lib/layouts/layouts';
import { RouteMeta } from 'vue-router';

export const defaultMeta: RouteMeta = {
  backButton: true,
  formConfig: null,
  layoutComponent: DefaultLayout,
  layoutPageTitle: null,
  pageTitle: null,
};

export const defaultMetaMedicalRequest = {
  ...defaultMeta,
  pageTitle: 'Medical Request',
  requiresLoadedTenant: true,
};

export const defaultMetaAdminRequest = {
  ...defaultMeta,
  pageTitle: 'Admin requests',
  requiresLoadedTenant: true,
};

// ENG-21797 Link-scoped flows. `resolvesState` marks a step that resolves from
// the endpoint, so direct entry renders its own state rather than being bounced.
export const defaultMetaMessages = {
  ...defaultMeta,
  pageTitle: 'Your message',
  requiresLoadedTenant: true,
  resolvesState: true,
};

export const defaultMetaAppointmentBooking = {
  ...defaultMeta,
  pageTitle: 'Book an appointment',
  requiresLoadedTenant: true,
  resolvesState: true,
};

export const defaultMetaAppointmentCancellation = {
  ...defaultMeta,
  pageTitle: 'Cancel your appointment',
  requiresLoadedTenant: true,
  resolvesState: true,
};

export const defaultMetaQuestionnaire = {
  ...defaultMeta,
  pageTitle: 'Your questionnaire',
  requiresLoadedTenant: true,
  resolvesState: true,
};

// NB. Reached only via a direct link containing the invoice id: no discovery tile on the
// portal landing page, and no back button on any page in this tree (explicit product
// decision). requiresValidPatient is deliberately never set here: access is gated purely
// by knowing the invoice id in the URL, matching the security model of the public payment
// pages this route tree replaces.
export const defaultMetaPayment = {
  ...defaultMeta,
  pageTitle: 'Pay your invoice',
  requiresLoadedTenant: true,
  backButton: false,
};

export const defaultNhsErrorMeta: RouteMeta = {
  nhsAppActions: {
    setBackAction: 'GO_BACK',
    goToPage: 'GO_BACK', //
    showBackNhsApp: true,
    showBackNhsAppWeb: false,
  },
};
